import { render, staticRenderFns } from "./ContentLeftTab.vue?vue&type=template&id=d13285ba&scoped=true"
import script from "./ContentLeftTab.vue?vue&type=script&lang=js"
export * from "./ContentLeftTab.vue?vue&type=script&lang=js"
import style0 from "./ContentLeftTab.vue?vue&type=style&index=0&id=d13285ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13285ba",
  null
  
)

export default component.exports